/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_ParentInputs */

const en_prop_parent = /** @type {(inputs: Prop_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent`)
};

const de_prop_parent = /** @type {(inputs: Prop_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordnet`)
};

/**
* | output |
* | --- |
* | "Parent" |
*
* @param {Prop_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_parent = /** @type {((inputs?: Prop_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_parent(inputs)
	return en_prop_parent(inputs)
});